// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__2IzA5","LabelDecoration":"Input_LabelDecoration__17tew","InputElement":"Input_InputElement__14zSw","Invalid":"Input_Invalid__egnK1"};